import styled from 'styled-components'

export const Wrapper = styled.section(
  ({ theme }) => `
    background: ${theme.colors.white};
    padding: 15px 10px;
    margin-top: 15px;
    order: 0;

    @media (min-width: ${theme.media.laptop.sm}) {
      order: 1;
      padding: 15px;
    }
  `
)

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  & p {
    margin: 0;
  }
`
